module.exports = __webpack_public_path__ + "static/img/img-about-5-1.8213943.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-5-1.png
// module id = i5UB
// module chunks = 0